import React, { FunctionComponent, useState, useEffect,useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@state/actions';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { AnyColor } from 'react-colorful/dist/types';
import { IBrand, IElementUpdate, IAddEditBrand, IBackUp, IDeleteBrand } from '../../state/brands/types';
import { IBrandImage } from '../../state/brandsImages/types';
import selectors from '@state/selectors';

export const BrandsContext = React.createContext(undefined as any);

export interface BrandsProviderProps {
}

export interface IBrandDetail {
    open: boolean;
    brand?: IBrand;
    organization?: string;  
}

export type IBrandImageSection = "logos" | "vehicles" | "stocks" | "backgrounds";

export type IActionValues = "add" | "replace" | "metadata" | "delete";

export interface IBrandAction {
    section: string;
    action: IActionValues;
    element: any;
}

export interface IViewAll {
    open: boolean;
    section?: string;
    pageTitle?: string;
    searchItemsValue?: string;
    selectedFilters?: any[]; 
}

export const BrandsProvider: FunctionComponent<any> = (props: React.PropsWithChildren<BrandsProviderProps>) => {
    const [searching, setSearching]= useState(false);
    const [searchValue, setSearchValue]= useState('');
    const [searchSelectedOne, setSearchSelectedOne]= useState(null);
    const [searchSelectedAll, setSearchSelectedAll]= useState(false);

    const [allFilters, setAllf]=useState([] as any);
    const [filters, setFilters]= useState({oem:[], platform:[],format:[], offerType:[]} as any);

    const [brandDetail, setBrandDetail] =useState<IBrandDetail|undefined>(undefined);

    const [brandAction, setBrandAction] =useState<IBrandAction|undefined>(undefined);

    const [viewAll, setViewAll] = useState<IViewAll|undefined>(undefined);

    //const [searchFolder, setSearchFolder]= useState('');

    const [sortByMenu, setSortBy]=useState([
        { title: "Name: ", extra:'(A-Z)', text:"A-Z", query:"c.name ASC"},
        { title: "Name: ", extra:'(Z-A)', text:"Z-A", query:"c.name DESC"},
        //{ title: "# of Sizes: ", extra:'(Small to Large)', text:"Smallest to Largest", query:"c.tags.formatCounter ASC"},
        //{ title: "# of Sizes: ", extra:'(Large to Small)', text:"Largest to Smallest", query:"c.tags.formatCounter DESC"},
        { title: "Last Edited: ", extra:'(New to Old)', text:"Newest to Oldest", query:"c.updateDate DESC"},
        { title: "Last Edited: ", extra:'(Old to New)', text:"Oldest to Newest", query:"c.updateDate ASC"}
    ] as any);
    const [sortByQuery, setSortByQuery]=useState('');
    const [sortByText, setSortByText]=useState('');

    const dispatch = useDispatch();
    const authContext = useContext(AuthContext);

    const addUpdateResponse = useSelector(selectors.brands.getAddUpdateBrand);

    useEffect(() => {
        if (addUpdateResponse) {
            setBrandDetail({open: true, brand:addUpdateResponse})
            setBrandAction(undefined);
        }
    }, [addUpdateResponse])

    useEffect(() => {
        if (brandDetail) setBrandAction(undefined)
        else {
            dispatch(actions.brands.setAddUpdateBrand(undefined));
            dispatch(actions.brands.setBrandName(undefined));
        }
    }, [brandDetail])

    useEffect(() => {
        if (!searching) {
            if (searchSelectedOne) setSearchSelectedOne(null);
            if (searchSelectedAll) setSearchSelectedAll(false);
        }
        if (searching) setFilters({oem:[], platform:[],format:[], offerType:[]} as any);
    }, [searching])

    useEffect(() => {
        if (sortByQuery==='') setSortByText('');
    }, [sortByQuery])

    const cleanFilters = () => {
        if (allFilters.length>0) {
            setAllf([]);
            setFilters({oem:[], platform:[],format:[], offerType:[]} as any);
        }
    }

    const fetchCounter = (folder:string) => {
        let query = getQuerySearchFilters(folder);
        //dispatch(actions.brands.set.setCounter({} as any));
        return new Promise((resolve, reject) => {
            dispatch(actions.brands.fetchCounterBrands(encodeURI('?filter='+query),(result, error) => {
                if (error) reject(error)
                else resolve(result);
            }))
        });
    }

    const getQuerySearchFilters = (folder:string) => {
        const state= `='ACTIVE'`;
        let query='';

        const userData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
          };

        //let searchFolderQuery = getQuerySearchByFolder(folder);
        let filterQuery = getFilterQuery();

        if(allFilters.length>0 && searching){
            query=`c.createdBy.email='${userData.email}' and c.status${state} ${filterQuery}`;
        }
        else if (allFilters.length>0 ){
            query=`(c.createdBy.email='${userData.email}' and c.designStatus${state} ${filterQuery})`;
        }
        else if (searching){
            query=`c.createdBy.email='${userData.email}' and c.status${state} `;
        }
        query = encodeURIComponent(query);
        return query;
    }

    /*const getQuerySearchByFolder = (folder:string) => {
        let searchByFolder = '';
        if (searchFolder!=='') folder = searchFolder;

        if (folder!=='' && folder!=='all') searchByFolder = ` c.folder='${folder}' and`;
        if (folder==='favorite') searchByFolder = ` c.favorite=true and`;
        return searchByFolder;
    }*/

    const getQuerySearch = () => {
        let searchQuery = '';

        if (searching){
            searchQuery=` and (c.name LIKE "%${encodeURIComponent(searchValue.toLowerCase())}%")`;
        }
        return searchQuery;
    }

    const handleChangeFilter=(value:any, type:string, add:boolean)=>{
        let typeFilters=filters[type]
        if(add) {
            typeFilters.push(value);
            setAllf([...allFilters, value]);
        }
        else {
            typeFilters=typeFilters.filter((item:any) => item !== value);
            setAllf(allFilters.filter((item:any) => item !== value));
        }
        
        setFilters({...filters, [type]: typeFilters});
    }

    const getFilterQuery = () => {
        let filtersQuery = '';
        if(filters){
            Object.keys(filters).forEach((key) => {
                let columQuery = '';
                if (filters[key].length>0){
                  columQuery = ` and c.tags.${key} IN (`;
      
                  filters[key].forEach((text:string, idx:number) => {
                    columQuery=`${columQuery}'${text}'`;
                    if (idx < filters[key].length-1) columQuery=`${columQuery},`;
                  });
      
                  columQuery=columQuery+`) `;
                }
                filtersQuery=filtersQuery+columQuery;
            });
        }
        return filtersQuery;
    }

    const handleRemoveFilterChip = (index: number) => {
        let value= allFilters[index];
        setAllf(allFilters.filter((val:any,idx:number) => index !== idx));

        var type = Object.keys(filters).find(k=>filters[k].includes(value));
        if(type){
            let newList=filters[type].filter((item:any) => item !== value)
            setFilters({...filters, [type]: newList});
        }
    }

    const handleChangeSortBy = (index: number) => {
        setSortByText(sortByMenu[index].text);
        setSortByQuery(sortByMenu[index].query);
    }


    const addUpdateBrand = async (elementsUpdate?: IElementUpdate[], name?: string, newId?: string,  oem?: boolean, industry?:string, brandAux?: IBrand, snackBarText?: string ) => {
        const userData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        };
        
        let addEditBrand : IAddEditBrand = {
            id: brandDetail?.brand?.id ?? newId ?? brandAux?.id ??  null,
            newBrand: newId ? true : false, 
            organization : brandAux?.organization??brandDetail?.organization??undefined,
            oem: oem!==undefined ?  oem : brandDetail?.brand?.oem ? brandDetail?.brand?.oem: false ,
            industry: industry,
            name: name ? name : brandDetail?.brand?.name,
            
            updatedBy: userData,
            elementsUpdate: elementsUpdate
        } ; 
        
        if (newId) addEditBrand.createdBy = userData;

        dispatch(actions.brands.addUpdateBrand(addEditBrand, snackBarText??"Changes Saved"));
        dispatch(actions.brands.setMovefileResponse(undefined));
    }


    const deleteRequest = async ()=>{
        dispatch(actions.brands.deleteBrandRequest())
    }
    const deleteBrand = async (id:string) => {
        const userData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        };
        
        let delBrand : IDeleteBrand = {
            id: id,
            updatedBy: userData
        } ;                  

        dispatch(actions.brands.deleteBrand(delBrand));        
    }


    const movefile = async (fileId: string) => {
        if (brandDetail?.brand && brandAction) {
            const backUpInformation : IBackUp = {
                brandId: brandDetail.brand.id,
                section: brandAction.section,
                imageId: fileId
            }
            dispatch(actions.brands.moveFile(backUpInformation));
        }
    }


    return (
        <BrandsContext.Provider value={{
            searching,
            setSearching: (val:boolean)=>setSearching(val),
            searchValue,
            setSearchValue: (val:string)=>setSearchValue(val),            
            searchSelectedOne,
            setSearchSelectedOne: (val:any)=>setSearchSelectedOne(val),
            searchSelectedAll,
            setSearchSelectedAll: (val:boolean)=>setSearchSelectedAll(val),            
            getQuerySearch: ()=>getQuerySearch(),
            filters,
            setFilters: (val:any)=>setFilters(val),
            allFilters,
            setAllf: (val:any)=>setAllf(val),
            handleChangeFilter: (val:any, type:string, add:boolean)=>handleChangeFilter(val, type, add),
            getFilterQuery: ()=>getFilterQuery(),
            handleRemoveFilterChip: (val:number)=>handleRemoveFilterChip(val),
            fetchCounter: (val:string)=>fetchCounter(val),
            cleanFilters: ()=>cleanFilters(),
            sortByMenu,
            sortByText,
            sortByQuery,
            setSortByQuery: (val:string)=>setSortByQuery(val),
            handleChangeSortBy: (val:number)=>handleChangeSortBy(val),
            brandDetail,  
            setBrandDetail: (val:IBrandDetail|undefined)=>setBrandDetail(val),
            brandAction,  
            setBrandAction: (val:IBrandAction|undefined)=>setBrandAction(val),
            addUpdateBrand: (elements?:IElementUpdate[], name?: string, newId?: string, oem?: boolean, industry?:string, brandAux?:IBrand, snackBarText?: string)=>addUpdateBrand(elements, name, newId, oem, industry, brandAux, snackBarText),
            deleteBrandRequest: ()=> deleteRequest(),
            deleteBrand: (id:string)=> deleteBrand(id),
            movefile: (fileId: string)=>movefile(fileId),
            viewAll,
            setViewAll: (val:IViewAll)=>setViewAll(val),
        }}>
            {props.children}
        </BrandsContext.Provider>
    )
}